module.exports = __webpack_public_path__ + "img/operator.f462705b.png";